/* ss-carrello.js — quantita' in metri, aggiornamento senza ricaricare */
(function () {
  var cart = document.querySelector('.ss-cart');
  if (!cart) return;

  function icona(seg) {
    return "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 " +
           "fill=%22%231E2224%22%3E" + seg + "%3C/svg%3E')";
  }
  var MENO = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E');
  var PIU  = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E%3Crect x=%2210.8%22 y=%224%22 width=%222.4%22 height=%2216%22 rx=%221.2%22/%3E');
  cart.querySelectorAll('[data-giu]').forEach(function (b) { b.style.backgroundImage = MENO; });
  cart.querySelectorAll('[data-su]').forEach(function (b) { b.style.backgroundImage = PIU; });

  var occupato = false;
  /* Shopify, se ricevi solo id e quantita', si tiene la proprieta' "Taglio"
     vecchia. Cambiando i metri da questa pagina restava scritto il metraggio
     di prima: l'ordine #6800 diceva "Taglio: 3,0 m" su una riga da 4 pezzi,
     cioe' 2 metri pagati e 3 tagliati. Va rimandata ricalcolata, come fa gia'
     il cassetto in ss-cassetto.js. */
  function etichettaTaglio(q, passo) {
    var m = q * passo;
    return (passo < 0.5 ? m.toFixed(2) : m.toFixed(1)).replace('.', ',') +
      ' m (' + q + ' \u00d7 ' + Math.round(passo * 100) + ' cm)';
  }
  function cambia(key, q, passo, aPezzo) {
    if (occupato) return;
    occupato = true;
    cart.style.opacity = '.55';
    var corpo = { id: key, quantity: q };
    if (!aPezzo && passo && q > 0) {
      corpo.properties = { 'Taglio': etichettaTaglio(q, passo) };
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); })
      .then(function () { location.reload(); })
      .catch(function () { occupato = false; cart.style.opacity = ''; });
  }

  cart.querySelectorAll('[data-riga]').forEach(function (riga) {
    var key = riga.getAttribute('data-key');
    var box = riga.querySelector('.ss-qta');
    var q = parseInt(box.getAttribute('data-q'), 10) || 1;
    var passo = parseFloat(box.getAttribute('data-passo')) || 0.5;
    var aPezzo = box.getAttribute('data-modo') === 'pezzo';
    var minimo = aPezzo ? 1 : Math.max(1, Math.round(0.5 / passo));

    riga.querySelector('[data-su]').addEventListener('click', function (e) {
      e.preventDefault(); cambia(key, q + 1, passo, aPezzo);
    });
    riga.querySelector('[data-giu]').addEventListener('click', function (e) {
      e.preventDefault();
      cambia(key, q > minimo ? q - 1 : 0, passo, aPezzo);
    });
    riga.querySelector('[data-togli]').addEventListener('click', function (e) {
      e.preventDefault(); cambia(key, 0, passo, aPezzo);
    });
  });

  /* la nota si salva da sola quando smetti di scrivere */
  var nota = cart.querySelector('[data-nota]');
  if (nota) {
    var timer = null;
    nota.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: nota.value })
        });
      }, 700);
    });
  }
})();
